import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useBusinessCard } from 'components/BusinessCard/context'
import { getUsers } from 'selectors/Account'
import { Section } from 'components/BusinessCard/components/StyledComponents'
import { H6, P } from '@PipelineDeals/shared-react-components'

const ProjectOwner = () => {
  const { t } = useTranslation()
  const {
    cardMeta: {
      showOnlyFields,
      showEmptyFields
    },
    resource: project
  } = useBusinessCard()

  const allUsers = useSelector(getUsers)

  const ownerName = useMemo(() => {
    if (!showOnlyFields.includes('owner') && !showOnlyFields.includes('owner_id')) return null

    if (project.owner) {
      return `${project.owner.first_name} ${project.owner.last_name}`
    }

    if (project.owner_id) {
      const owner = allUsers.find(user => user.id === project.owner_id)
      return owner?.full_name
    }

    return null
  }, [project, showOnlyFields, allUsers])

  const showOwner = useMemo(() =>
    showOnlyFields.includes('owner') || showOnlyFields.includes('owner_id'),
  [showOnlyFields])

  if (!showOwner) return null
  if (!showEmptyFields && !ownerName) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.owner')}</H6>
      <P>{ownerName || t('businessCard.labels.unassigned')}</P>
    </Section>
  )
}

export default ProjectOwner
